import { hasLaunchedSoftphone } from 'components/CallScribe/popout';

const RETURN_THROTTLE_MS = 2000;

export const subscribeToPodReturn = (onReturn: () => void): (() => void) => {
  let last = Number.NEGATIVE_INFINITY;
  const handle = (): void => {
    if (document.visibilityState === 'hidden' || !hasLaunchedSoftphone()) return;
    const now = Date.now();
    if (now - last < RETURN_THROTTLE_MS) return;
    last = now;
    onReturn();
  };
  document.addEventListener('visibilitychange', handle);
  window.addEventListener('focus', handle);
  return () => {
    document.removeEventListener('visibilitychange', handle);
    window.removeEventListener('focus', handle);
  };
};
